import axios from "axios"

import { API_URL } from "../../config/appConfig"

export const ORG_BASE_URL = `${API_URL}/api/OrganizationStages`

export const getOrganizationStages = (headers: any) => {
  return axios.get(`${ORG_BASE_URL}`, { headers })
}

export const getOrganizationStagesByOrgId = (organizationStagePk: number) => {
  return axios.get(`${ORG_BASE_URL}/${organizationStagePk}/issuerstages`)
}

export const postOrganizationStagesByOrgId = (organizationStagePk: number, payload: any) => {
  return axios.post(`${ORG_BASE_URL}/${organizationStagePk}/issuerstages`, payload)
}

export const processOrganizationStagesByOrgId = (organizationStagePk: number, payload: any) => {
  return axios.post(`${ORG_BASE_URL}/${organizationStagePk}/process`, payload)
}

export const OrgStageHasPendingIssuerStages = (organizationStagePk: number) => {
  return axios.get(`${ORG_BASE_URL}/${organizationStagePk}/issuerstages/haspending`)
}

export const getOrgStageByOrgStageId = (organizationStageModelId: number) => {
  return axios.get(`${ORG_BASE_URL}/${organizationStageModelId}`)
}

export const updateOrgStage = (organizationStagePk: number, payload: any) => {
  return axios.put(`${ORG_BASE_URL}/${organizationStagePk}`, payload)
}

export const postOrganizationStage = (payload: any, params : any) => {
  return axios.post(`${ORG_BASE_URL}`, payload, {params})
}